// growl notifications
// wrapper for pnotify


bq.growl = {
  notify: [], //collection of all notifications
  options: {},
  stack: {"dir1": "up", "dir2": "right", "push": "top", "spacing1": 5, "spacing2": 5, "firstpos1": 25, "firstpos2": 0},
  variables: {
    body: $('body'),
    bodyPadding: false,
    timeout: false,
    oldHeight: false
  },

  init: function(opt) {
    this.options = $.extend({}, bq.growl.DEFAULTS, opt);

    //set up events to catch
    $(document).on('bq.notification', {thiz: this}, this.catchEventNotification);
    $(document).on('bq.updateNotification', {thiz: this}, this.catchEventUpdate);
    $(document).on('bq.removeNotification', {thiz: this}, this.catchEventRemove);

  },

  createNotification: function(opt) {
    var tmpOptions = this.updateOptions(opt);
    this._notification(opt.id, tmpOptions);
  },

  updateNotification: function(opt) {
    var tmpOptions = this.updateOptions(opt);
    this._notification(opt.id, tmpOptions);
  },

  removeNotification: function(opt) {
      this._notification(opt.id, opt, true);
  },

  _notification: function(id, o, remove) {

    if(!id && !o.id) { return; }
    if(!id && o.id) { id = o.id; }

    if(remove && this.notify[id]) {
       this.notify[id].remove();
    }

    if(remove) { return; }

    if(!this.notify[id]) {
        this.notify[id] = new PNotify(o);
    } else {
        this.notify[id].update(o);
    }

  },

  updateOptions: function(opt) {
    var $this = this;

    if(opt.type === 'loading') {
      opt.type = 'info';
      //opt.addclass = opt.addclass + ' bq-notify-loading';
      opt.styling.info = "bq-notify-loading";
      opt.hide = false;
    }

    if(opt.type === 'highlight-success') {
        opt.type = 'success';
        opt.addclass = opt.addclass + ' bq-notify-highlight';
    }

    if(opt.type === 'error') {
      opt.addclass = opt.addclass + ' bq-notify-error';
    }

    opt.after_close = function(notify) {
        $this.notify[notify.options.id] = null;
    };

    opt.after_init = function(notify) {
      $this.addAttributes(notify.elem);
    };

    return opt;
  },

  catchEventNotification: function(e, options) {
    var $this = e.data.thiz;
    var newOptions = $.extend({}, $this.options, options);

    bq.debug.log("Growl : catchEventNotification", newOptions);

    $this.createNotification(newOptions);

    // AB Show pnotify
    $('.ui-pnotify').addClass('ui-pnotify-in');

  },

  catchEventUpdate: function(e, options) {
    var $this = e.data.thiz;
    var newOptions = $.extend({}, $this.options, options);

    bq.debug.log("Growl : catchEventUpdate", newOptions);

    $this.updateNotification(newOptions);
  },

  catchEventRemove: function(e, options) {
    var $this = e.data.thiz;
    var newOptions = $.extend({}, $this.options, options);

    bq.debug.log("Growl : catchEventRemove", newOptions);

    $this.removeNotification(newOptions);
  },

  addAttributes: function(elem) {
    if (this.options.attributes.length > 0) {
      this.options.attributes.forEach(function(attribute){
        $(elem).attr(attribute.label, attribute.value);
      });
    }
  }
};

bq.growl.DEFAULTS = {
    id: '',
    title: false,
    text: false,
    styling: {
        container: "bq-notify",
        notice: "bq-notify-warning bq-alert-icon bq-alert-warning",
        info: "bq-notify-info bq-alert-icon bq-alert-info",
        success: "bq-notify-success bq-alert-icon bq-alert-success",
        error: "bq-notify-error bq-alert-icon bq-alert-error",
        closer: "bq-notify-close"
    },
    addclass: "stack-bottomleft bq-notify-container",
    width: "335px",
    type: "notice",
    icon: false,
    shadow: false,
    hide: true,
    delay: 8000,
    stack: bq.growl.stack,
    buttons: {
        closer: true,
        closer_hover: false,
        sticker: false
    },
    animation: "fade",
    attributes: [
      {
        label: 'aria-hidden',
        value: 'true'
      }
    ],
    mobile: {
      swipe_dismiss: false
    }
};
